<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Cities of {{ provinceData.province }}<b>({{ provinceData.provinceCode }})</b></h1>
<div mat-dialog-content>
  <form>
    <div>
      <div class="expert__assign">
        <ol>
            <li *ngFor="let city of provinceData.provinceCities; let i = index">{{ city.cityName }}</li>
        </ol>
      </div>
    </div>
  </form>
</div>